module.exports = __webpack_public_path__ + "img/logooooooo.1265ec3e.png";